import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type PaymentContext as SchemaPaymentContext } from '../schemas/PaymentContext';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const GetDigitalOrderPaymentContextContentType = '' as const;
export type GetDigitalOrderPaymentContextRequest = undefined;
export type GetDigitalOrderPaymentContextResponses = LinkCommonErrorResponses & {
    /**
     * @description Digital order payment context
     */
    '200': {
        'application/json': SchemaPaymentContext;
    };
};
export type GetDigitalOrderPaymentContextResponseSuccess =
    GetDigitalOrderPaymentContextResponses['200']['application/json'];
export type GetDigitalOrderPaymentContextSearchParams = {
    on_error_redirect?: string;
    on_success_redirect?: string;
    on_abort_redirect?: string;
    signature: string;
    initial_payment_options?: string;
    logged_in: boolean;
};
export type GetDigitalOrderPaymentContextPathParameters = {
    store_slug: string;
    order_id: string;
};
export const GetDigitalOrderPaymentContextUrl = '/{store_slug}/digital_orders/{order_id}/payment_context' as const;
export const GetDigitalOrderPaymentContextMethod = 'GET' as const;
export const getGetDigitalOrderPaymentContextUrl = (params: GetDigitalOrderPaymentContextPathParameters) =>
    GetDigitalOrderPaymentContextUrl.replace(
        /\{(\w+)\}/g,
        (_match, param: keyof GetDigitalOrderPaymentContextPathParameters) => String(params[param])
    );
